module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/mv_photowedding_01@2x-e0042b04ceeb5d4ae69f4d8e267a6658.webp";